export default __webpack_public_path__ + "static/vb1-d1edade6b8121d36e4a2573abfa2a215.jpg";